// Component to render the profile card
// Import react
import React, { useState, useEffect } from "react";

// Import supabase configuration
import supabase from "../../config/supabase";
import { useRef } from "react";
// Import button
import { Buffer } from "buffer";
import Button from "../../components/button/button";

export default function Profile({
  profile,
  getId,
  currentProfile,
  showModal,
  setProfileid,
  setValue,
  showNewModal,
  proccessed=false,
  justView = true,
  token="",
}) {

  const [url, setUrl] = useState("/blurry.svg");
  const [skillsListLength, setSkillsListLength] = useState(window.screen.availWidth >= 1024 ? 4 : 2);


  useEffect(() => {
    var flag = false;
    if(profile?.skill_level.length > 0) {
      profile.skill_level.slice(0,skillsListLength).map((obj)=>{
        if(obj.skill.length >= 15) {
          flag = true;
        }
      });
    }
    if(flag) {
      setSkillsListLength(window.screen.availWidth >= 1024 ? 3 : 1);
    } else {
      setSkillsListLength(window.screen.availWidth >= 1024 ? 4 : 2);
    }
  },[])

  const handleOnClick = () => {
    getId(profile.id);
  }

  return (
    // Function to render the content
    <div className="w-full h-auto relative container cursor-pointer" onClick={handleOnClick}>
      {/* show image if profile is scheduled */}
      {
        ((profile?.meetingTime && localStorage.getItem("supabase.auth.token")) || (!localStorage.getItem("clientUrl") && profile?.meetingTime && !localStorage.getItem("supabase.auth.token") && !token) || (localStorage.getItem("clientUrl") && sessionStorage.getItem("publicInfo") && profile?.meetingTime && !localStorage.getItem("supabase.auth.token") && token)) && <div className="absolute -right-2 -top-2">
          <img src="/schd.svg" className="object-none"/>
        </div>
      }

      {/* Add card */}
      <div className={`rounded bg-white-1 shadow-clientCard h-auto grid grid-cols-12 gap-3 p-6 box-border ${currentProfile == profile ? 'border-blue-1 border-2' : ''} `}>

        {/* Column for avatar */}
        <div className="col-span-12 sm:col-span-3 lg:col-span-2 flex items-center relative h-[45px] w-[45px] md:h-emoji md:w-emoji md:pt-10">
        {/* Render image if provided */}
        {profile.emoji_url ? (
            // Render imgae
            <img className="" src={profile?.emoji_url ? profile.emoji_url : url} />
        ) : (
            // Render placeholder
            <div className="w-emoji h-emoji bg-white-3 flex items-center">
              {/* Render text */}
              <div className="text-center w-full text-lg text-white-1 font-normal">
                  {profile.full_name && profile.full_name[0].toUpperCase()}
              </div>
            </div>
        )}
        </div>

        {/* Column for details */}
        <div className="col-span-12 sm:col-span-9 lg:col-span-10 grid grid-cols-12 gap-3">
        {/* Column for name and email*/}
        <div className="col-span-12">
            {/* Render name */}
            <div className="w-full text-lg font-text text-black-1 font-normal">
              {profile.full_name}
            </div>

        </div>

        {/* Column for location and exp */}
        <div className="col-span-6">
            {/* Render location */}
            {profile.location ? (
            <div className="w-full mb-3 text-sm font-light text-black-1 flex items-center">
                {/* Icon */}
                <img className="mr-2 h-4 -ml-0.5" src="/location.png" alt="Avatar" />

                {/* Text */}
                {profile.location} 
            </div>
            ) : null}

            {/* Render exp */}
            {profile.exp ? (
            <div className="w-full text-[10px] font-normal text-black-2">
                <div>EXPERIENCE</div>
                <div className="text-black-1 text-sm">
                {/* Text */}
                {profile.exp} Years
                </div>
            </div>
            ) : null}
        </div>

        {/* Column for experience and contract */}
        <div className="col-span-6">
            {/* Render exp */}
            {profile.timezone ? <div className="text-sm font-light flex mb-2" >
                <svg className="mt-0.5 -ml-0.5 h-4 w-4 fill-current text-black-1 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z"/></svg>
                {profile.timezone.split(" ")[0].replace(/[\(\)]/g, "")}
            </div>
            : null}

            {/* Render expected_hourly_rate */}
            {profile.client_hourly_rate ? (
            <div className="w-full text-sm font-semibold text-black-1">
                <div className="text-black-2 text-[10px] font-normal"> {profile?.paymentFrequency && (profile.paymentFrequency === 'Hourly' ?  'HOURLY RATE' : profile.paymentFrequency === 'Monthly' ? 'MONTHLY COMPENSATION' : 'YEARLY COMPENSATION')} </div>
                {/* Text */}
                <div>${new Intl.NumberFormat().format(profile.client_hourly_rate)}</div>
            </div>
            ) : null}
        </div>

        </div>

        {/* Add space */}
        <div className="hidden md:block col-span-2"></div>

        {/* Show skills */}
        <div className="col-span-12 md:col-span-10 flex flex-wrap">
        {/* Render tags */}
        {profile.skill_level.length > 0
          ? profile.skill_level.length > skillsListLength ? <div className="flex">{
              profile.skill_level.slice(0,skillsListLength).map((element, index) => (
                <div
                key={index}
                className={`text-black-1 text-sm p-1 mr-2 rounded-sm border-blue-7 bg-white-1 border-2 font-text whitespace-nowrap`}
                >
                {element.skill && element.skill[0].toUpperCase() + element.skill.slice(1)}
                </div>
              ))  } 
              <div className="text-black-1 text-sm p-1 mr-2 w-10 text-center rounded-md border-blue-7 bg-blue-7 border-2 font-text whitespace-nowrap"> +{profile.skill_level.length - skillsListLength}</div> </div> :
              profile.skill_level.map((element, index) => (
                <div
                key={index}
                className={`text-black-1 text-sm p-1 mr-2 rounded-sm border-blue-7 bg-white-1 border-2 font-text whitespace-nowrap`}
                >
                {element.skill && element.skill[0].toUpperCase() + element.skill.slice(1)}
                </div>
              ))
          : null}
        </div>
      </div>

    </div>
  );
}
